module.exports = "https://static.wmbcdn.com/uniweb/images/3e1efbca8ce7dfb62bcce5caf287dfbc.svg";